import initTheme from "./scripts/theme";
import initChat from "./scripts/chat";
// Post page: post.html?slug=<slug>
import { api, esc, formatDate, renderMarkdown } from "./blog/api";

initTheme();
// Kamado on the blog too: readers can ask about the author
initChat();

const article = document.getElementById("article");
const slug = new URLSearchParams(location.search).get("slug");

function showMessage(title, text) {
  article.innerHTML = `<div class="article__empty">
    <h1 class="article__title">${esc(title)}</h1>
    <p>${esc(text)}</p>
    <a class="btn btn--dark btn--sm" href="/#blog">See all posts</a>
  </div>`;
  article.removeAttribute("aria-busy");
}

// Interactive figures: a post writes <div data-figure="name"></div> and gets
// /figures/<name>.html in a frame that follows the site's theme. Only the
// figures listed here are embedded.
const FIGURES = { "kamado-sorter": "Kamado's answer sorter, an interactive figure" };

function embedFigures(root) {
  const theme = () => (document.documentElement.dataset.theme === "dark" ? "dark" : "light");
  const srcFor = (name) => `/figures/${name}${theme() === "light" ? "-light" : ""}.html`;
  const frames = [];
  for (const slot of root.querySelectorAll("[data-figure]")) {
    const name = slot.dataset.figure;
    if (!FIGURES[name]) continue;
    const frame = document.createElement("iframe");
    frame.className = "figure-frame";
    frame.title = FIGURES[name];
    frame.loading = "lazy";
    frame.dataset.figure = name;
    frame.style.colorScheme = theme();
    frame.src = srcFor(name);
    slot.replaceWith(frame);
    frames.push(frame);
  }
  if (!frames.length) return;
  window.addEventListener("message", (e) => {
    if (e.origin !== location.origin || typeof e.data?.height !== "number") return;
    const frame = frames.find((f) => f.contentWindow === e.source);
    if (frame) frame.style.height = `${e.data.height}px`;
  });
  new MutationObserver(() => {
    for (const frame of frames) {
      const src = srcFor(frame.dataset.figure);
      if (!frame.src.endsWith(src)) {
        frame.style.colorScheme = theme();
        frame.src = src;
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
}

async function load() {
  if (!slug) {
    showMessage("No post selected", "Pick a post from the blog.");
    return;
  }
  try {
    const p = await api(`/api/posts/${encodeURIComponent(slug)}`);
    document.title = `${p.title} | Abdelilah Bouchikhi`;
    document.querySelector('meta[name="description"]').setAttribute("content", p.summary || p.title);
    const tags = p.tags.map((t) => `<a class="chip" href="/#blog">#${esc(t)}</a>`).join("");
    article.innerHTML = `
      <p class="article__meta">${esc(formatDate(p.published_at))} · ${p.reading_minutes} min read</p>
      <h1 class="article__title">${esc(p.title)}</h1>
      ${p.summary ? `<p class="article__lead">${esc(p.summary)}</p>` : ""}
      ${tags ? `<div class="article__tags">${tags}</div>` : ""}
      <div class="prose">${renderMarkdown(p.content)}</div>`;
    embedFigures(article);
    article.removeAttribute("aria-busy");
  } catch (err) {
    if (err.status === 404) showMessage("Post not found", "It may have been moved or unpublished.");
    else showMessage("Couldn't load this post", "The blog is taking a break. Please try again in a moment.");
  }
}

load();
